import { getDatabase } from 'firebase/database'

import app from './app'
// Initialize Cloud Firestore and get a reference to the service
const database = getDatabase(app)

export default database
